import { api } from './client'

export const listEligible = (pid) =>
  api.get(`/certificates/programs/${pid}/eligible`).then((r) => r.data)
export const sendVerificationCodes = (pid, enrollmentIds) =>
  api.post(`/certificates/programs/${pid}/send-code`, { enrollmentIds }).then((r) => r.data)
// FR-24: one-shot bulk issue + send to all eligible. `classId` optional —
// scopes the batch to one class, matching whatever the Send Code screen is
// currently displaying (see AdminCertSendScreen's class-scoped `refresh`).
export const issueAllCertificates = (pid, classId) =>
  api
    .post(`/certificates/programs/${pid}/issue-all`, null, { params: classId ? { class_id: classId } : {} })
    .then((r) => r.data)
export const myCertificates = () =>
  api.get('/certificates/mine').then((r) => r.data)
export const claimCertificate = (email, code) =>
  api.post('/claim', { email, code }).then((r) => r.data)
export const verifyCertificate = (certNo) =>
  api.get(`/verify/${certNo}`).then((r) => r.data)
export const forceEligible = (pid, enrollmentId) =>
  api.post(`/certificates/programs/${pid}/enrollments/${enrollmentId}/force-eligible`).then((r) => r.data)
// Analitik kredensial: apa yang terjadi pada sertifikat setelah ia terbit.
// `range` opsional — { from, to } dalam bentuk YYYY-MM-DD.
export const certAnalytics = (pid, range = {}) =>
  api.get(`/certificates/programs/${pid}/analytics`, { params: range }).then((r) => r.data)
export const certAnalyticsFor = (pid, certId) =>
  api.get(`/certificates/programs/${pid}/certificates/${certId}/analytics`).then((r) => r.data)

export const getCertificateTemplate = (pid) =>
  api.get(`/certificates/programs/${pid}/template`).then((r) => r.data)
export const updateCertificateTemplate = (pid, data) =>
  api.put(`/certificates/programs/${pid}/template`, data).then((r) => r.data)
export const uploadCertificateAsset = (pid, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return api.post(`/certificates/programs/${pid}/upload-asset`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((r) => r.data)
}

